import React from 'react';
import { Box } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { UploadedFileInfo } from 'src/types';

type DataVisualizationActionsProps = {
  isPreviewMode: boolean;
  onResetToUpload?: () => void;
  onUpload?: () => void;
  onApproveFiles?: (fileInfo: UploadedFileInfo) => void;
  isUploading: boolean;
  currentFileInfo?: UploadedFileInfo | null;
  areCurrentFilesApproved: boolean;
};

export const DataVisualizationActions: React.FC<
  DataVisualizationActionsProps
> = ({
  isPreviewMode,
  onResetToUpload,
  onUpload,
  onApproveFiles,
  isUploading,
  currentFileInfo,
  areCurrentFilesApproved,
}) => {
  if (!isPreviewMode) {
    return null;
  }

  const showOtherFilesButton = Boolean(onResetToUpload);
  const showUploadButton = Boolean(onUpload);
  const showApproveButton = Boolean(onApproveFiles && currentFileInfo);

  if (!showOtherFilesButton && !showUploadButton && !showApproveButton) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="row" justifyContent="end" gap={4} mt={6}>
      {showOtherFilesButton && (
        <Button
          buttonName="Other files"
          onClick={onResetToUpload}
          bg="icon.green"
          color="white"
          borderRadius="lg"
          w={{ base: '100%', md: '160px' }}
          alignSelf="center"
          fontSize="16px"
          fontWeight={600}
          _hover={{
            opacity: 0.9,
          }}
          _disabled={{
            bg: 'icon.green',
            cursor: 'not-allowed',
            opacity: 0.5,
          }}>
          Other files
        </Button>
      )}

      {showUploadButton && (
        <Button
          buttonName="Upload"
          onClick={onUpload}
          bg="icon.green"
          color="white"
          borderRadius="lg"
          w={{ base: '100%', md: '160px' }}
          alignSelf="center"
          fontSize="16px"
          fontWeight={600}
          isDisabled={isUploading}
          _hover={{
            opacity: 0.9,
          }}
          _disabled={{
            bg: 'gray.400',
            cursor: 'not-allowed',
            opacity: 0.6,
          }}>
          {isUploading ? 'Uploading...' : 'Upload'}
        </Button>
      )}

      {showApproveButton && (
        <Button
          buttonName="Approve"
          onClick={() => currentFileInfo && onApproveFiles?.(currentFileInfo)}
          bg="icon.green"
          color="white"
          borderRadius="lg"
          w={{ base: '100%', md: '160px' }}
          alignSelf="center"
          fontSize="16px"
          fontWeight={600}
          isDisabled={areCurrentFilesApproved}
          _hover={{
            opacity: 0.9,
          }}
          _disabled={{
            bg: 'gray.400',
            cursor: 'not-allowed',
            opacity: 0.6,
          }}>
          {areCurrentFilesApproved ? 'Approved' : 'Approve'}
        </Button>
      )}
    </Box>
  );
};
